import { useEffect, useState } from 'react';
import { isUndefined, isEmpty } from 'lodash-es';

import useAuthStore, { ProfileWithExtendedData } from '@store/AuthStore';

import useEducationPlannerStore from '@store/EducationPlannerStore';

export const useNeedMoreUserInfo = () => {
  const { userData, userCard } = useAuthStore((state) => state.authSession);
  const {
    dateOfBirth,
    plan,
    graduationYear: reconciledGraduationYear,
  } = (userData?.profile ?? {}) as ProfileWithExtendedData;
  const graduationYear = userCard ? userCard.graduationYear : reconciledGraduationYear;
  const userPlanning = useEducationPlannerStore((state) => state.userPlanning);

  const [needMoreInfo, setNeedMoreInfo] = useState(false);

  useEffect(() => {
    if (!isUndefined(userData) && !isEmpty(userPlanning)) {
      const needMoreInfo =
        (!graduationYear && !plan?.now) ||
        (!userPlanning?.beginCollege?.year &&
          !userPlanning?.beginCollege?.season &&
          !userPlanning?.beginCollege?.other) ||
        !dateOfBirth;

      setNeedMoreInfo(needMoreInfo);
    }
  }, [userData, userPlanning, dateOfBirth, plan, graduationYear]);

  return needMoreInfo;
};
